<template>
	<div 
		id="app"
		ref="app"
	>
		<div 
			v-if="!(isHome || isConnection || isAnalytics)"
			class="sticky-header"
			:class="[
				{ sticky: sticky }
			]"
		>	
			<div class="container">
				<router-link
					tag="strong"
					to="/"
					class="sticky-header__title"
					v-html="meta.title"
				/>

				<router-link
					to="/connection"
					tag="div"
					class="live-connection-sticky"
				>
					<button-ui
						text="Connection"
						icon="dot-circle"
						small
						left
						theme="white"
					/>
				</router-link>

				<div class="menu-button">
					<font-awesome-icon 
						v-if="routeName !== 'tableOfContents'"
						icon="bars" 
						@click="openMobileMenu()"
					/>

					<router-link
						v-else
						to="/"
						tag="div"
					>
						<font-awesome-icon 
							icon="home" 
						/>
					</router-link>
				</div>
			</div>
		</div>

		<mobile-menu />

		<main
			:class="{ 'content': !isHome }"
		>
			<router-view></router-view>

			<footer
				v-if="!(isHome || isConnection || isAnalytics)"
				class="content-footer"
			>
				<div class="container">
					<div class="content-footer__content">
						&copy; Copyright 2019, {{ meta.author }} 
						<!-- <a :href="`mailto:${meta.authorEmail}`" >{{ meta.authorEmail }}</a> -->
					</div>
				</div>
			</footer>
		</main>

		<div 
			v-if="isHome"
			class="home-footer"
		>
			<div class="home-footer__meta-info">
				<ul>
					<li><strong>{{ meta.author }}</strong><small>Author</small></li>
					<li><strong>{{ meta.volume }}</strong><small>Volume</small></li>
					<li><strong>{{ meta.lang }}</strong><small>Language</small></li>
				</ul>
			</div>

			<router-link
				to="/connection"
				tag="div"
				class="live-connection-btn"
			>
				<button-ui
					text="Connection"
					icon="dot-circle"
					small
					left
					theme="white"
				/>
			</router-link>

			<router-link
				to="/table-of-contents"
				tag="div"
				class="home-footer__toc"
			>
				<button-ui
					text="Table of Contents"
					icon="bars"
					small
					left
				/>
			</router-link>

			<router-link
				to="/chapter/1"
				tag="div"
			>
				<button-ui
					text="Chapter 1"
					icon="angle-right"
					small
					right
				/>
			</router-link>
		</div>
	</div>
</template>

<script>
	import ButtonUi from '@/ui/components/ButtonUI';
	import MobileMenu from '@/ui/components/MobileMenu';

	import meta from '@data/meta.json';
	import { setTimeout } from 'timers';

	export default {
		name: 'app',
		components: {
			ButtonUi,
			MobileMenu
		},
		data() {
			return {
				sticky: true,
				menuTimer: 500
			}
		},
		computed: {
			meta() {
				return meta;
			},
			isHome() {
				return this.$route.name === 'home';
			},
			isConnection() {
				return this.$route.name === 'connection';
			},
			isAnalytics() {
				return this.$route.name === 'analytics';
			},
			routeName() {
				return this.$route.name;
			}
		},
		watch: {
			routeName() {
				this.setScreen();
			}
		},
		mounted() {
			this.setScreen();
		},
		methods: {
			setScreen() {
				document.querySelector('body').setAttribute('data-screen', this.routeName);
			},
			openMobileMenu() {
				const body = document.querySelector('body')
				
				body.setAttribute('data-menu', 'active');
				setTimeout(() => {
					body.setAttribute('data-menu-visible', 'active');
				}, this.menuTimer);

				setTimeout(() => {
					body.setAttribute('data-menu-content', 'active');
				}, this.menuTimer * 2);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.sticky-header {
		position: fixed;
		top: 0;

		.container {
			display: flex;
			align-items: center;
		}

		padding: 0.4em 0em 0.3em;
		width: 100%;

		&__title {
			display: none;
			color: $_copy;
			font-family: 'Josefin';
			flex: 1;
			position: relative;

			/deep/ strong {
				display: block;
			}

			&:before {
				content: "";
				@include box(20px);
				background: url('./design-system/media/images/heart.png') no-repeat;
				background-position: center;
				display: block;
				position: absolute;
				left: 0;
				@include centerY();
				display: none;
			}
		}

		&.sticky {
			background:  $primary;
			color: $_copy;
			box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);

			.sticky-header {
				&__title {
					display: block;
					cursor: pointer;
				}
			}
		}
	}

	.menu-button {
		display: flex;
		@include box(40px);
		border-radius: 2px;
		font-size: 1.6em;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		opacity: 0.7;
	}

	main {
		&.content {
			padding: calc(50px + 1.5em) 0 1.5em;
		}
	}

	.home-footer {
		position: fixed;
		bottom: 0;
		width: 100%;
		height: 70px;
		background: linear-gradient(to top, rgba($primary, 0.98) 0%, rgba($primary, 0.9) 90%, transparent 100%);

		display: flex;
		align-content: center;
		align-items: center;
		justify-content: center;

		&:before {
			content: "";
			width: 70%;
			height: 1px;
			background: rgba($secondary, 0.2);
			position: absolute;
			top: 0;
			@include centerX();

			@include desktop {
				width: 100%;
			}
		}

		&__meta-info {
			display: none;
			color: $secondary;

			ul {
				margin: 0;
				padding: 0;

				li {
					margin: 0;
					padding: 0;
					list-style: none;
					display: inline-block;
					margin-right: 2em;

					small {
						display: block;
						text-transform: uppercase;
					}
				}
			}
		}

		@include tablet {
			padding: 0 3em;
			width: calc(100% - 6em);
			justify-content: flex-end;

			.home-footer {
				&__meta-info {
					display: flex;
					flex: 1;
				}
			}
		}
	}


	.content-footer {
		margin: 2em 0 1em 0;
		&__content {
			padding-top: 1.5em;
			border-top: 1px solid #e0e0e0;
			font-size: 0.89em;
			color: #888888;
			text-align: center;

			a {
				color: inherit;
				text-decoration: none;
				font-weight: bold;
			}
		}
	}

	.live-connection-btn {
		display: none;

		@include desktop {
			display: block;
		}
	}
</style>

